import { render } from "./CercaModal.vue?vue&type=template&id=92af6330&ts=true"
import script from "./CercaModal.vue?vue&type=script&lang=ts"
export * from "./CercaModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__